import type { ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { isReturningFocus } from '@/hooks/useDialogFocusReturn';

import styles from './Tooltip.module.css';

interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
}

export function Tooltip({ children, content }: TooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger
        asChild
        // The tooltip opens on focus, but not on focus a closing dialog gives
        // back: it would cover the page the person came back to (#92, #173).
        onFocus={(event) => {
          if (isReturningFocus(event.currentTarget)) {
            event.preventDefault();
          }
        }}
      >
        {children}
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          className={styles.content}
          side="top"
          sideOffset={8}
        >
          {content}
          <TooltipPrimitive.Arrow className={styles.arrow} height={8} width={14} />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
